var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "36.447px",
    height: "36.447px",
    viewBox: "0 0 36.447 36.447",
    style: {
      enableBackground: "new 0 0 36.447 36.447"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.224,3.948h-1.098V2.75c0-1.517-1.197-2.75-2.67-2.75c-1.474,0-2.67,1.233-2.67,2.75v1.197h-2.74V2.75 c0-1.517-1.197-2.75-2.67-2.75c-1.473,0-2.67,1.233-2.67,2.75v1.197h-2.74V2.75c0-1.517-1.197-2.75-2.67-2.75 c-1.473,0-2.67,1.233-2.67,2.75v1.197H6.224c-2.343,0-4.25,1.907-4.25,4.25v24c0,2.343,1.907,4.25,4.25,4.25h24 c2.344,0,4.25-1.907,4.25-4.25v-24C34.474,5.855,32.567,3.948,30.224,3.948z M25.286,2.75c0-0.689,0.525-1.25,1.17-1.25 c0.646,0,1.17,0.561,1.17,1.25v4.896c0,0.689-0.524,1.25-1.17,1.25c-0.645,0-1.17-0.561-1.17-1.25V2.75z M17.206,2.75 c0-0.689,0.525-1.25,1.17-1.25s1.17,0.561,1.17,1.25v4.896c0,0.689-0.525,1.25-1.17,1.25s-1.17-0.561-1.17-1.25V2.75z M9.125,2.75 c0-0.689,0.525-1.25,1.17-1.25s1.17,0.561,1.17,1.25v4.896c0,0.689-0.525,1.25-1.17,1.25s-1.17-0.561-1.17-1.25V2.75z  M31.974,32.198c0,0.965-0.785,1.75-1.75,1.75h-24c-0.965,0-1.75-0.785-1.75-1.75v-22h27.5V32.198z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.724,
    y: 14.626,
    width: 4.595,
    height: 4.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.857,
    y: 14.626,
    width: 4.596,
    height: 4.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.995,
    y: 14.626,
    width: 4.595,
    height: 4.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.128,
    y: 14.626,
    width: 4.596,
    height: 4.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.724,
    y: 20.084,
    width: 4.595,
    height: 4.086
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.857,
    y: 20.084,
    width: 4.596,
    height: 4.086
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.995,
    y: 20.084,
    width: 4.595,
    height: 4.086
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.128,
    y: 20.084,
    width: 4.596,
    height: 4.086
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.724,
    y: 25.54,
    width: 4.595,
    height: 4.086
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.857,
    y: 25.54,
    width: 4.596,
    height: 4.086
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.995,
    y: 25.54,
    width: 4.595,
    height: 4.086
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.128,
    y: 25.54,
    width: 4.596,
    height: 4.086
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.83e254428c381a85f82f1b0af752f9c8.svg";
export { ForwardRef as ReactComponent };